import React from "react";
import PositionEnum from "../../enums/position.enum";
import classMap from "../../helpers/classMap";
import Icon from "../icon/icon";
import EnhancedIconProps from "./enhanced-icon.props";
import "./enhanced-icon.scss";

const EnhancedIcon = (props: EnhancedIconProps) => {
  let textClass = "";
  if (props.title) {
    if (props.textPosition === PositionEnum.LEFT) {
      textClass = "left";
    } else if (props.textPosition === PositionEnum.RIGHT) {
      textClass = "right";
    }
  }

  const icon =
    props.alt === undefined ? (
      <div className={classMap("enhanced-icon-icon", props.enhancedClassName)}>
        <Icon {...props} title={props.title} />
      </div>
    ) : (
      <div className={classMap("enhanced-icon-icon", props.enhancedClassName)}>
        <Icon {...props} title={props.title} alt={props.alt} />
      </div>
    );

  const text = (
    <div className={classMap("enhanced-icon-text", props.textClassName, textClass)}>
      <span>{props.title}</span>
    </div>
  );

  const position: PositionEnum = props.textPosition ? props.textPosition : PositionEnum.LEFT;
  const before: boolean = position === PositionEnum.TOP || position === PositionEnum.LEFT;
  const enhancedIcon = before ? (
    <>
      {text}
      {icon}
    </>
  ) : (
    <>
      {icon}
      {text}
    </>
  );
  const vertical: boolean = position === PositionEnum.TOP || position === PositionEnum.BOTTOM;
  const classes: string = vertical ? "vertical" : "horizontal";

  return <div className={classMap("mpng-ux-enhanced-icon", props.enhancedIconClassName, classes)}>{enhancedIcon}</div>;
};

export default EnhancedIcon;
